<template>
  <div class="w_content">
		<div class="women">
			<a href="#"><h4>AWARDEES </h4></a>
		
		     <div class="clearfix"></div>	
			 	<h1 v-if="loadingTag">Loading........</h1>
		     <div class="clearfix"></div>	
		</div>
        
        
		<!-- grids_of_4 -->
		<!--<div class="grids_of_4"> -->
		 <div class="grid1_of_4" v-for="profiles in dataObject" v-bind:key="profiles._id">
				<div class="content_box">
			   	   	 <img :src="profiles.awardeeProfileImage" class="img-responsive" style="width: 280px; height: 200px; pointer: finger;" alt="">
				   	  
				    <h3> {{profiles.awardName}} </h3>
					<p>{{profiles.awardeeCountry}} </p>
					 <h4>{{profiles.awardYear}} - {{profiles.honour}}</h4>
				     <p>{{profiles.context}} </p>
					 <div class="grid_1 simpleCart_shelfItem">
				    
					 <div class="item_add"><span class="item_price" style="color: black;"><h6>{{profiles.awardeeBirthYear}} - {{profiles.awardeeDeathYear}}</h6></span></div>
					<div class="item_add"><span class="item_price" @click="viewProfile(profiles._id)"><a href="">VIEW</a></span></div>
					 </div>
			   	</div>
				   <div class="clearfix"></div>
				   <p></p>
				   <p></p>
			</div>
			<p></p>
			<p></p>
			<div class="clearfix"></div>
		<!-- </div>-->
		
		
		
        
			<div class="clearfix"></div>
            <p></p>
			<p></p>
			<div style="text-align: center;">
           <p>Page {{this.paginationLinks.currentPage}} of Page {{this.paginationLinks.pageCount}}</p>
        </div> 
  		<div style="text-align: center;">
            <button @click="prev()" class="btn btn-default"> <i><</i> Prev</button> | <button @click="next()" class="btn btn-default">Next <i>></i></button>
        </div>    
            <div style="text-align: center;">
					<h4 v-if="loadingPager">Loading........</h4>
		     <div class="clearfix"></div>
			  </div>	
		</div>
		
		
		
		<!-- end grids_of_4 -->
		
		
	
</template>

<script>
import axios from "axios";

export default {
  name: 'landingPage',
  props: {
  
},
data()
{
	return{
		Id: null,
		dataObject: [],
		paginationLinks: {},
		page: 1,
		loadingTag: true,
		loadingPager: false

	}
},
async mounted()
{
	///localStorage.setItem("token","noToken");
	//fire axios get request
	try{
		let response = await axios.get(`https://time-person-mofe.herokuapp.com/api/profiles/all?page=${this.page}`);
		this.dataObject = response.data.itemsList;
		this.paginationLinks = response.data.paginator;
		   this.loadingTag = false;
		//console.log(JSON.stringify(response.data.itemsList));
	}
	catch(error)
	{
		alert("Oops something went wrong please refresh page");
	}
		//console.log(this.dataObject);
		//console.log(this.paginationLinks);

},
methods:
{
	viewProfile: function(profileId)
	{
		this.Id = profileId;
		this.$router.push(`/timeawards/profileView/awardee/${this.Id}`);
	},
	next: function()
	{
		//alert(JSON.stringify(this.paginationLinks));
		if(this.paginationLinks.hasNextPage == true)
		{
					this.loadingPager = true;
			this.page = this.paginationLinks.next;
			this.getData();
		}
	},
	prev: function()
	{
		if(this.paginationLinks.hasPrevPage == true)
		{
				this.loadingPager = true;
			this.page = this.paginationLinks.prev;
			this.getData();
		}
	},
	getData: async function()
	{
		//fire axios get request
	try{
		let response = await axios.get(`https://time-person-mofe.herokuapp.com/api/profiles/all?page=${this.page}`);
		this.dataObject = response.data.itemsList;
		this.paginationLinks = response.data.paginator;
		//console.log(JSON.stringify(response.data.itemsList));
		this.loadingPager = false;
	}
	catch(error)
	{
		alert("Oops something went wrong please refresh page");
	}
	}
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
